export default __webpack_public_path__ + "static/media/coming-soon-sm.2af8be87.png";